import { useEffect, useRef } from 'react';

export const useAfterRenderEffect = (func: () => void, deps: React.DependencyList) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      func();
    }
    else {
      isMounted.current = true;
    }
    // eslint-disable-next-line
  }, deps);
};